// @hat-tip:  http://stackoverflow.com/a/16349631
export default
function (ngModule) {
    ngModule.directive('imageAvailable', [function(){
        'use strict';

        return {
            restrict: 'A',
            scope: {
                options: '=',
                // Pull in the ng-src attribute. The directive has no controller, and thus no interface.
                // What you see is what we get.
                // NOTE: This intentionally does not use src. Do not use src - the browser will try to load your image pre-interpolation. That = bad.
                //       For bo-src, the src is NOT set in stone, so that won't work. We could enhance this to support single bindings, though...
                ngSrc: '@'
            },
            link: function imageAvailableLink($scope) {
                var checkImage;

                function cleanupCheckImage() {
                    if (checkImage !== null && checkImage !== undefined) {
                        angular.element(checkImage).off('load', 'error');
                        angular.element(checkImage).remove();
                        checkImage = null;
                    }
                }

                $scope.$watch('ngSrc', function watchImageAvailable(newSrc) {
                    // Create a new temporary element with our src, and see if it breaks.
                    checkImage = angular.element('<img/>')
                    checkImage.attr("src", newSrc)
                    checkImage.on('load', function onLoad() {
                            if(checkImage[0].height >= $scope.options.minimumImageSize.height
                                && checkImage[0].width >= $scope.options.minimumImageSize.width) {
                                    $scope.$evalAsync(function evaluateLater() {
                                        $scope.options.onMediaAvailable();
                                    });
                            }
                            cleanupCheckImage();
                        })
                        .on('error', function errorLoading() {
                            cleanupCheckImage();
                        });
                });

                $scope.$on('$destroy', function onWidgetDestroyed() {
                    cleanupCheckImage();
                });
            }
        };
    }]);
}



// WEBPACK FOOTER //
// ./source/components/image-available/image-available.js